"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { getRegisterMetadataApi, type SelectOption, type TimezoneOption } from "../services/auth.api";
import { isBackendUnavailableError } from "../utils/isBackendUnavailableError";

type RegisterMetadataState = {
  countries: SelectOption[];
  timezones: TimezoneOption[];
  languages: SelectOption[];
  loading: boolean;
  errorKey: string;
};

export function useRegisterMetadata(): RegisterMetadataState {
  const [countries, setCountries] = useState<SelectOption[]>([]);
  const [timezones, setTimezones] = useState<TimezoneOption[]>([]);
  const [languages, setLanguages] = useState<SelectOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [errorKey, setErrorKey] = useState("");

  useEffect(() => {
    let isActive = true;

    const loadMetadata = async () => {
      try {
        const metadata = await getRegisterMetadataApi();

        if (!isActive) {
          return;
        }

        setCountries(metadata.countries);
        setTimezones(metadata.timezones);
        setLanguages(metadata.languages);
        setErrorKey("");
      } catch (error: unknown) {
        if (!isActive) {
          return;
        }

        if (isBackendUnavailableError(error)) {
          setErrorKey("backend_unavailable");
        } else if (axios.isAxiosError(error)) {
          setErrorKey("metadata_failed");
        } else {
          setErrorKey("metadata_failed");
        }
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };

    void loadMetadata();

    return () => {
      isActive = false;
    };
  }, []);

  return { countries, timezones, languages, loading, errorKey };
}
